
import axois from '../utils/axiosExport'
 
export function AuthRegister(data?: any) {
  return axois.request({
    url: `/admin/auth/register`,
    method: "POST",
    data: {
      ...data,
    },
  });
} 
export function AuthResetPassword(data?: any) {
  return axois.request({
    url: `/admin/auth/reset-password`,
    method: "POST",
    data: {
      ...data,
    },
  });
} 
export function AuthLogout(data?: any) {
  return axois.request({
    url: `/admin/auth/logout`,
    method: "POST",
    data: {
      ...data,
    },
  });
} 
export function AuthLogin(data?: any) {
  return axois.request({
    url: `/admin/auth/login`,
    method: "POST",
    data: {
      ...data,
    },
  });
} 
export function AuthGetInviteCodeGenerate(data?: any) {
  return axois.request({
    url: `/admin/invitation-code/generate`,
    method: "POST",
    data: {
      ...data,
    },
  });
} 
// 获取邀请码
export function AuthGetInviteCode(data?: any) {
  return axois.request({
    url: `/admin/invitation-code/get`,
    method: "get",
    data: {
      ...data,
    },
  });
}